import { Header } from "@general-backoffice/core";
import React from "react";
import { Col, Container, Row } from "reactstrap";

import useReferrersHierarchyStats from "../../../../../components/adminStats/hooks/useReferrersHierarchyStats";
import MonthlyReferrersEarningsGraphCard from "../../../../../components/adminStats/MonthlyReferrerEarningsGraphCard";

const AffiliatesEarnings: React.FC = () => {
  const referrersHierarchyStatsProps = useReferrersHierarchyStats();

  return (
    <React.Fragment>
      <Header.BreadCrumb color="secondary" isDark={false}></Header.BreadCrumb>
      <Container className="mt--6" fluid>
        <Row>
          <Col xl={12}>
            <MonthlyReferrersEarningsGraphCard {...referrersHierarchyStatsProps} />
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default AffiliatesEarnings;
